import ManageHome from "@/views/pc/manageHome/index.vue";
import ManagerLayout from "@/views/pc/ManageLayout.vue";
import Login from "@/views/pc/Login.vue";
import Home from "@/views/pc/Home.vue";
import Gallery from "@/views/pc/Gallery.vue"
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const constantRoutes = [
  {
    path: "/",
    redirect: "/Home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    // TODO: 后续删除/:menu?
    path: "/manageHome/:menu?",
    name: "ManageHome",
    component: ManageHome,
    meta: {
      requiresAuth: true,
      keepAlive: true, //需要被缓存的组件
    },
  },
  {
    path: "/myFavorites",
    name: "MyFavorites",
    component: () => import('@/views/pc/myFavorites/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery,
    meta: {
      requiresAuth: true,
      keepAlive: false, //需要被缓存的组件
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      keepAlive: false, //需要被缓存的组件
    },
  },
  {
    path: "/manage",
    name: "Manage",
    component: ManagerLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      //任务中心首页
      {
        path: "/manage",
        name: "manage",
        component: () => import("@/views/pc/Comhome.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //全部商机
      {
        path: "/manage/allcom",
        name: "allcom",
        component: () => import("@/views/pc/Allcom.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //创建项目
      {
        path: "/manage/newproject",
        name: "newproject",
        component: () => import("@/views/pc/NewProject.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //创建项目
      {
        path: "/manage/newproject/:id/:tid",
        /* 解决：Duplicate named routes definition */
        name: "newprojectParams",
        component: () => import("@/views/pc/NewProject.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },

      //编辑项目
      {
        path: "/manage/editproject/:id",
        name: "editproject",
        component: () => import("@/views/pc/NewProject.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //立即创建（跳转）
      {
        path: "/manage/doclist",
        name: "task",
        component: () => import("@/views/pc/DocumentList.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //选择模块
      {
        path: "/manage/newdoc/:id",
        name: "NewDocument",
        component: () => import("@/views/pc/NewDocument.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //商机类型
      {
        path: "/manage/selecttype/:id",
        name: "selecttype",
        component: () => import("@/views/pc/SelectType.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //编辑文档
      {
        path: "/manage/editdocument/:id/:did",
        name: "editdocument",
        component: () => import("@/views/pc/EditDocument.vue"),
        // component: () => import("@/views/pc/EditDocument.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      {
        path: "/manage/addcover/:id/:did/:fileType",
        name: "addcover",
        component: () => import("@/views/pc/AddCover.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //业绩清单
      {
        path: "/manage/performanceList",
        name: "performanceList",
        component: () => import("@/views/pc/performanceList.vue"),
        meta: {
          keepAlive: true, //需要被缓存的组件
        },
      },
      //项目详情
      {
        path: "/manage/projectDetails/:id/:num",
        name: "projectDetails",
        component: () => import("@/views/pc/projectDetails.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //项目编辑
      {
        path: "/manage/projectEditing/:id",
        name: "projectEditing",
        component: () => import("@/views/pc/projectEditing.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //总部项目档案
      {
        path: "/manage/pDetails/:id/:num",
        name: "pDetails",
        component: () => import("@/views/pc/pDetails.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //总部项目档案
      {
        path: "/manage/noPermission",
        name: "noPermission",
        component: () => import("@/views/pc/noPermission.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //资料查询
      {
        path: "/manage/newDataQueries",
        name: "dataQueries",
        component: () => import("@/views/pc/newDataQueries.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
      //客户中心
      {
        path: "/manage/customManage",
        name: "customManage",
        component: () => import("@/views/pc/customManage.vue"),
        meta: {
          keepAlive: true, //需要被缓存的组件
        },
      },
      //查看详情
      {
        path: "/manage/detailsTalk",
        name: "detailsTalk",
        component: () => import("@/views/pc/detailsTalk.vue"),
        meta: {
          keepAlive: false, //需要被缓存的组件
        },
      },
    ],
  },
];

export default constantRoutes;
